import Star from "lucide-react/dist/esm/icons/star";
import inhaberAvif220 from "@/assets/luca-inhaber-220.avif";
import inhaberAvif280 from "@/assets/luca-inhaber-280.avif";
import inhaberAvif385 from "@/assets/luca-inhaber-385.avif";
import inhaberAvif560 from "@/assets/luca-inhaber-560.avif";
import inhaberWebp220 from "@/assets/luca-inhaber-220.webp";
import inhaberWebp280 from "@/assets/luca-inhaber-280.webp";
import inhaberWebp385 from "@/assets/luca-inhaber-385.webp";
import inhaberWebp560 from "@/assets/luca-inhaber-560.webp";

const avifSrcSet = `${inhaberAvif220} 220w, ${inhaberAvif280} 280w, ${inhaberAvif385} 385w, ${inhaberAvif560} 560w`;
const webpSrcSet = `${inhaberWebp220} 220w, ${inhaberWebp280} 280w, ${inhaberWebp385} 385w, ${inhaberWebp560} 560w`;

const InhaberCard = () => {
  return (
    <div className="relative w-full">
      <div
        className="absolute -top-12 -left-12 w-72 h-72 bg-accent/20 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div
        className="absolute -bottom-12 -right-12 w-96 h-96 bg-primary/15 rounded-full blur-3xl pointer-events-none"
        aria-hidden="true"
      />

      <div className="relative flex justify-center pointer-events-none">
        <div className="relative z-10">
          <div
            className="absolute inset-0 -m-8 bg-gradient-to-br from-accent/30 via-primary/10 to-transparent rounded-full blur-2xl"
            aria-hidden="true"
          />
          <picture>
            <source type="image/avif" srcSet={avifSrcSet} sizes="(max-width: 640px) 220px, (max-width: 1024px) 260px, 280px" />
            <source type="image/webp" srcSet={webpSrcSet} sizes="(max-width: 640px) 220px, (max-width: 1024px) 260px, 280px" />
            <img
              src={inhaberWebp280}
              alt="Familie Luca – Ihre Gastgeber in Cuxhaven-Duhnen"
              width={280}
              height={280}
              loading="lazy"
              decoding="async"
              className="relative w-[220px] sm:w-[260px] lg:w-[280px] h-auto object-contain drop-shadow-2xl"
            />
          </picture>
        </div>
      </div>

      <div className="relative -mt-12 sm:-mt-14 z-20">
        <div className="glass-card rounded-2xl p-6 sm:p-8 pt-16 sm:pt-20 shadow-2xl border border-white/40 backdrop-blur-xl bg-card/85 text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/15 text-accent-strong text-xs font-body font-semibold tracking-wider uppercase mb-4">
            <Star className="w-3.5 h-3.5" /> Ihre Gastgeber seit 1986
          </span>
          <h3 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-gradient-ocean leading-tight">
            Familie Luca
          </h3>
          <p className="mt-1 font-body text-sm sm:text-base text-foreground/75 italic">
            Inhaber & persönliche Ansprechpartner vor Ort
          </p>
          <p className="mt-5 font-body text-base sm:text-lg text-foreground/90 leading-relaxed">
            Seit fast 40 Jahren vermitteln wir mit Herz und Erfahrung Ferienwohnungen
            in Cuxhaven-Duhnen und Döse. Als familiengeführtes Unternehmen in zweiter
            Generation kennen wir jede unserer Wohnungen persönlich – und freuen uns
            darauf, auch Ihren Nordseeurlaub unvergesslich zu machen.
          </p>
          <p className="mt-3 font-body text-base text-foreground/75 leading-relaxed">
            Direkt, ehrlich, ohne Plattformgebühren. Sprechen Sie uns gerne an –
            wir beraten Sie persönlich.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InhaberCard;
